export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_job_type/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_job_type/update', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_job_type/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop_job_type/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/ShopJobType.js